module.exports = __webpack_public_path__ + "static/media/save_icon.9730a05b.png";